var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPicsart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.192 1.68457H50.8064C23.6766 1.68457 1.68359 23.6776 1.68359 50.8074V205.193C1.68359 232.323 23.6766 254.316 50.8064 254.316H205.192C232.322 254.316 254.315 232.323 254.315 205.193V50.8074C254.315 23.6776 232.322 1.68457 205.192 1.68457Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.021 142.034C115.674 142.034 99.9336 126.293 99.9336 106.946C99.9336 87.5987 115.674 71.8584 135.021 71.8584C154.369 71.8584 170.109 87.5987 170.109 106.946C170.109 126.293 154.369 142.034 135.021 142.034ZM135.021 85.8935C123.414 85.8935 113.969 95.3391 113.969 106.946C113.969 118.553 123.414 127.999 135.021 127.999C146.628 127.999 156.074 118.553 156.074 106.946C156.074 95.3391 146.628 85.8935 135.021 85.8935Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.013 170.105C100.185 170.105 71.8555 141.768 71.8555 106.947C71.8555 72.1259 100.185 43.7891 135.013 43.7891C169.841 43.7891 198.171 72.1259 198.171 106.947C198.171 141.768 169.841 170.105 135.013 170.105ZM135.013 57.8242C107.933 57.8242 85.8906 79.8592 85.8906 106.947C85.8906 134.035 107.933 156.07 135.013 156.07C162.094 156.07 184.136 134.035 184.136 106.947C184.136 79.8592 162.094 57.8242 135.013 57.8242Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9081 212.21C81.3011 212.21 71.8555 202.765 71.8555 191.158V106.947H85.8906V191.158C85.8906 195.024 89.0344 198.175 92.9081 198.175C96.7818 198.175 99.9256 195.024 99.9256 191.158V156.07H113.961V191.158C113.961 202.765 104.515 212.21 92.9081 212.21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.0696,
    y1: 239.93,
    x2: 239.929,
    y2: 16.0705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D523D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#BC43DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8588EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#5DBBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#44DAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BE6FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsart);
export default __webpack_public_path__ + "static/media/picsart.f869489b2038fd1afb4ed047c1ef8bf7.svg";
export { ForwardRef as ReactComponent };